"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const LogMessageType_1 = require("@/common/logs/LogMessageType");
const LogMessageDataType_1 = require("@/common/logs/LogMessageDataType");
const TileType_1 = require("@/common/TileType");
const Log_1 = require("@/common/logs/Log");
const ClientCardManifest_1 = require("@/client/cards/ClientCardManifest");
const UndergroundResourceToken_1 = require("@/common/underworld/UndergroundResourceToken");
const spaces_1 = require("@/common/boards/spaces");
const cardTypeToCss = {
    event: 'background-color-events',
    corporation: 'background-color-global-event',
    active: 'background-color-active',
    automated: 'background-color-automated',
    prelude: 'background-color-prelude',
    ceo: 'background-color-ceo',
    standard_project: 'background-color-standard-project',
    standard_action: 'background-color-standard-project',
    proxy: undefined,
};
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'LogMessageComponent',
    props: {
        message: {
            type: Object,
            required: true,
        },
        viewModel: {
            type: Object,
            required: true,
        },
    },
    methods: {
        cardToHtml(data) {
            const card = (0, ClientCardManifest_1.getCard)(data.value);
            if (card === undefined) {
                return '';
            }
            const attrs = data.attrs;
            const suffixFreeCardName = card.name.split(':')[0];
            const className = cardTypeToCss[card.type];
            if (className === undefined) {
                return suffixFreeCardName;
            }
            let tagHTML = '';
            if (attrs?.tags === true) {
                tagHTML = '&nbsp;' + (card.tags.map((tag) => `<div class="log-tag tag-${tag}"></div>`).join(' '));
            }
            let costHTML = '';
            if (attrs?.cost === true) {
                costHTML = `<span>&nbsp;<div class="log-resource-megacredits">${card.cost}</div></span>`;
            }
            return '<span class="log-card ' + className + '">' + this.$t(suffixFreeCardName) + tagHTML + costHTML + '</span>';
        },
        getPlayerName(color) {
            const player = this.viewModel.players.find((player) => player.color === color);
            return player?.name ?? color;
        },
    },
    computed: {
        entries() {
            if (this.message === undefined) {
                return [];
            }
            const e = {
                message: this.$t(this.message.message),
                data: this.message.data,
            };
            return Log_1.Log.parse(e);
        },
        when() {
            return new Date(this.message.timestamp).toLocaleString();
        },
        icon() {
            return this.message.playerId === undefined ? '&#x1f551;' : '&#x1f4ac;';
        },
        LogMessageType() {
            return LogMessageType_1.LogMessageType;
        },
        LogMessageDataType() {
            return LogMessageDataType_1.LogMessageDataType;
        },
        getSpaceName() {
            return spaces_1.getSpaceName;
        },
        isMoonSpace() {
            return spaces_1.isMoonSpace;
        },
        isStealMessage() {
            return this.message?.message?.includes('stole') ?? false;
        },
        undergroundResourceTokenDescription() {
            return UndergroundResourceToken_1.undergroundResourceTokenDescription;
        },
        tileTypeToString() {
            return TileType_1.tileTypeToString;
        },
    },
});
